import { render, staticRenderFns } from "./StatusListaDeEsperaContent.vue?vue&type=template&id=1b5fc442&scoped=true"
import script from "./StatusListaDeEsperaContent.vue?vue&type=script&lang=js"
export * from "./StatusListaDeEsperaContent.vue?vue&type=script&lang=js"
import style0 from "./StatusListaDeEsperaContent.vue?vue&type=style&index=0&id=1b5fc442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5fc442",
  null
  
)

export default component.exports